"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadelLoading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PadelLoading = () => {
    const bounceClasses = [
        'animate-bounce-delay-0',
        'animate-bounce-delay-1',
        'animate-bounce-delay-2',
    ];
    const shadowClasses = [
        'animate-shadow-delay-0',
        'animate-shadow-delay-1',
        'animate-shadow-delay-2',
    ];
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-full h-full flex items-center justify-center overflow-visible", children: (0, jsx_runtime_1.jsx)("div", { className: "flex gap-4 items-end", children: [0, 1, 2].map((i) => ((0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [(0, jsx_runtime_1.jsx)("div", { className: bounceClasses[i], children: (0, jsx_runtime_1.jsxs)("svg", { width: "36", height: "36", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "10", fill: "#d9f99d" }), (0, jsx_runtime_1.jsx)("path", { d: "M4,10 C8,8 16,16 20,14", stroke: "#fefce8", strokeWidth: "1.5", fill: "none" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: `absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-1 rounded-full bg-gray-400 opacity-30 ${shadowClasses[i]}` })] }, i))) }) }));
};
exports.PadelLoading = PadelLoading;
